import ReceiptTemplateForm from './receipt-template-form.vue';
export default ReceiptTemplateForm;
